import MapDraw from 'map/MapDraw';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMapActionStore from 'stores/action';
import useColorSetStore from 'stores/colorSet';
import useFloorStore from 'stores/floor';
import useTransportStore from 'stores/transport';
import { PathType } from 'types/common/common.type';
import useDomainStore from 'stores/domain';
import styles from './TransportPopup.module.scss';

type TransportPopupProps = {
  closeModal: () => void;
};

const TransportPopup = ({ closeModal }: TransportPopupProps) => {
  // hook
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { clientPath } = useParams();

  // store
  const transportStore = useTransportStore();
  const floorStore = useFloorStore();
  const mapActionStore = useMapActionStore();
  const themeStore = useColorSetStore();
  const domainStore = useDomainStore();

  const onClick = (transportType: string) => {
    // domainType 에 따라 link 분기
    if (domainStore.isWeb()) {
      navigate(`/${domainStore.getContext()}/${clientPath}/${PathType.floor}`);
    } else {
      navigate(`/${PathType.floor}`, { replace: true });
    }

    transportStore.setCurrentTransport(transportType);
    mapActionStore.setMapAction('navigation', true);
    floorStore.setCurrentFloorId(MapDraw.machine.floor.id);

    closeModal();
  };

  return (
    <div className={styles.container}>
      <div>{t('popup.transport.desc')}</div>

      <div className={styles.transport_wrapper}>
        {transportStore.transports.map(transport => (
          <div
            style={{ background: themeStore.sub }}
            className={styles.transport}
            key={transport}
            onClick={onClick.bind(this, transport)}
          >
            <div className={styles.icon}>
              <img src={`/assets/popup/transport/${transport}.svg`} alt='transport' />
            </div>
            <span>{t(`popup.transport.method.${transport}`)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
export default TransportPopup;
